export enum HierarchyType {
    Division = 1,
    DeliveryCenter = 2,
    ServiceCenter = 3,
    Ams = 4
}